import { Button } from '@mui/material';

interface ProviderSeeProfileProps {
  url: string;
  onClick: () => void;
  isMobileOrSmaller: boolean;
}

const ProviderSeeProfile = ({ url, onClick, isMobileOrSmaller }: ProviderSeeProfileProps) => {
  return (
    <Button
      fullWidth={isMobileOrSmaller}
      color="secondary"
      component="a"
      href={url}
      onClick={onClick}
      size={isMobileOrSmaller ? 'medium' : 'small'}
      sx={{
        minWidth: isMobileOrSmaller ? 'auto' : '144px',
      }}
      variant="contained">
      See profile
    </Button>
  );
};

export default ProviderSeeProfile;
